const DownloadResume = () => {
  const link = document.createElement('a');
  link.href = "Tony-Tran-Resume.pdf";
  link.download = "Tony-Tran-Resume.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default DownloadResume
